import { Component, OnInit } from "@angular/core";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { Router, ActivatedRoute } from "@angular/router";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { DialogThresholdSettingsComponent } from "../dialog-threshold-settings/dialog-threshold-settings.component";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ParametersChartComponent } from "../parameters-chart/parameters-chart.component";
import moment from "moment-timezone";
import { AngularCsv } from "angular7-csv/dist/Angular-csv";
import { C } from "@angular/cdk/keycodes";
import { CommonModule } from "@angular/common";
@Component({
  selector: "app-parameters-list",
  templateUrl: "./parameters-list.component.html",
  styleUrls: ["./parameters-list.component.scss"],
  standalone: true,
  providers: [ConvertDatetimePipe, BackendApiService, BaseUrlConstantsService],
  imports: [CommonModule]
})
export class ParametersListComponent implements OnInit {
  public allParameters = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public parametersHistoricalData =
    BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public parametersThrsholdApi = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public today: Date;
  public company_name: string;
  public breadcrumbsArray: any = [
    {
      page_ref: "Boiler Parameters",
      page_title: "Boiler Parameters",
    },
    // {
    //   page_ref: "#",
    //   page_title: "Trend Analysis",
    // },
  ];
  public clientId: string;
  public loader: boolean = false;
  public deviceId: string;
  public parametersList: any = [];
  public pageName: any;
  public downloadChartDataOn: boolean;
  public dtDataForCSVARRAY: any[];
  public parametersCsvOption = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Eboiler All parameters Data",
    useBom: true,
    noDownload: false,
    headers: ["Name", "Value"],
  };
  parametersList1: any;
  public ChartDataForParameter: any[];
  public parameterChartColors: any[];
  public parameterChartOptions: any;
  public parameterChartData: any;
  public parameterChartloading: boolean;
  public GraphScaleSettingData: any;
  public assetId: string;
  public subsystemId: any;
  public showEmptyError: string = "";
  public subsystem_name: string;
  public firingRateChartData: any = [];
  public movingAvg: any;
  chartloader: boolean;
  totalParameters: any;
  public plc1Parameters: any;
  public plc2Parameters: any;
  public dtDataForCSVARRAY2: any[];
  public plc1ParametersOneday: any=[];
  public plc2ParametersOneday: any=[];
  public downloading: boolean=false;
  public tabName = 'tab-4';
  public tab1: any;
  public tab2: any;
  public tab3: any;
  public tab4: any;
  constructor(
    public service: BackendApiService,
    public activeRoute: ActivatedRoute,
    public router: Router,
    private dialog: MatDialog
  ) {
    this.subsystemId = localStorage.getItem("subsystem_id");
    this.clientId = localStorage.getItem("user_id");
    if (localStorage.getItem("role") === "ADMIN") {
      this.clientId = localStorage.getItem("admin_client_id");
    }
    else if(localStorage.getItem("role") === "CLIENT"){
      this.clientId = localStorage.getItem("user_id");
    }
    else {
      // this.clientId = localStorage.getItem("user_id");
      this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
    }
    this.utcTime();
    this.getAllParameters();
    activeRoute.queryParams.subscribe(async (params) => {
      // console.log(params, "params");
      this.tabName = params["tabName"],
        this.tab1 = params["tab1"],
        this.tab2 = params["tab2"],
        this.tab3 = params["tab3"],
        this.tab4 = params["tab4"],
      this.pageName = params[`pageRef`];
      this.subsystem_name = params[`pageRef`]["subsystem_name"];

      if (this.pageName === "Boiler-Dashboard") {
        const myObj = {
          page_ref: "eBoiler-dashboard",
          page_title: "Boiler Dashboard",
        };
        this.breadcrumbsArray.unshift(myObj);
      }
      if (this.pageName === "Device-Room") {
        const myObj = {
          page_ref: "eBoiler-room-devices",
          page_title: "Device Room",
        };
        this.breadcrumbsArray.unshift(myObj);
      }
    });
  }

  ngOnInit(): void {
    this.company_name = localStorage.getItem("company_name");
    this.subsystemId = localStorage.getItem("subsystem_id");
    this.getAllParametersOneDaydata()
  }
  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 :this.tab2,
        tab3 :this.tab3,
        tab4 :this.tab4,
      },
    };
    this.router.navigate([name],navigationExtras);
  }
  getAllParameters() {
    this.service
      .getData(
        this.allParameters +
          "all-parameters/latest/" +
          this.clientId +
          "/" +
          this.subsystemId
      )
      .then((res) => {
        let response = JSON.parse(JSON.stringify(res)).data;
        if (response.status === "success") {
          if (response.body.sensor.length != 0) {
            this.showEmptyError = "";
            this.plc1Parameters = response.body.PLC1;
            this.plc2Parameters = response.body.PLC2;
            this.parametersList = response.body.sensor;
            this.parametersList = this.parametersList.map(setting=> {return{...setting,loader:false}});

            console.log(this.parametersList, "parameterlist");
          } else {
            this.showEmptyError = "NO Parameters available..";
          }
        } else {
          this.showEmptyError = "NO Parameters available..";
        }
      });
  }
  getAllParametersOneDaydata(){
    this.service
      .getData(
        this.allParameters +
          "all-parameters/oneday/" +
          this.clientId +
          "/" +
          this.subsystemId
      )
      .then((res) => {
        let response = JSON.parse(JSON.stringify(res)).data;
        if (response.status === "success") {
          if (response.body.sensor.length != 0) {
            this.showEmptyError = "";
            this.plc1ParametersOneday = response.body.PLC1;
            this.plc2ParametersOneday = response.body.PLC2;
            return true;
            // this.parametersList = response.body.sensor;
            // console.log(this.parametersList, "parameterlist");
          } else {
            this.showEmptyError = "NO Parameters available..";
            return false;
          }
        } else {
          this.showEmptyError = "NO Parameters available..";
          return false;
        }
      });
  }
  downloadParametersValue() {
    this.downloading=true;
    this.getAllParametersOneDaydata()
    console.log(this.parametersList, "parameterslist");
    console.log(this.plc1ParametersOneday,this.plc2ParametersOneday)
  
    // Assuming each object in totalParameters (PLC1) has the same keys
    if (this.plc1ParametersOneday.length === 0 && this.plc2ParametersOneday.length === 0) {
      console.log("No data to export");
      this.downloading=false;
      this.service.showSuccess("No data to export");
      return;
    }
  
    const keys1 = this.plc1ParametersOneday.length ? Object.keys(this.plc1ParametersOneday[0]) : [];
    const headers1 = ["index", "Datetime", ...keys1];
  
    // Prepare data for PLC1
    const plc1DataForCSV = this.plc1ParametersOneday.map((item, index) => {
      let obj = {
        index: index,
        Datetime: new ConvertDatetimePipe().convertDateTime(
          moment(item.Datetime).format("YYYY-MM-DD HH:mm:ss")
        ),
      };
      // Add all key-value pairs from the item
      keys1.forEach((key) => {
        obj[key] =
          item[key] === "0" ? "off" : item[key] === "1" ? "on" : item[key];
      });
      return obj;
    });
  
    // Assuming each object in parametersList (PLC2) has the same keys
    if (this.plc2ParametersOneday.length !== 0) {
      const keys2 = Object.keys(this.plc2ParametersOneday[0]);
      const headers2 = ["index", "Datetime", ...keys2];
  
      // Prepare data for PLC2
      console.log(this.plc2ParametersOneday, 'plc2 para');
      const plc2DataForCSV = this.plc2ParametersOneday.map((item, index) => {
        let obj = {
          index: index,
          Datetime: new ConvertDatetimePipe().convertDateTime(
            moment.utc(item.Datetime).toDate()
          ),
        };
        // Add all key-value pairs from the item
        keys2.forEach((key) => {
          obj[key] =
            item[key] === "0" ? "off" : item[key] === "1" ? "on" : item[key];
        });
        return obj;
      });
  
      // Combine data with a separator row and headers
      const headingPLC1 = {
        index: "PLC1 Data",
        Datetime: "",
        ...keys1.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
      };
      const headingPLC2 = {
        index: "PLC2 Data",
        Datetime: "",
        ...keys2.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
      };
      const separatorRow = {
        index: "",
        Datetime: "",
        ...keys1.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
      };
  
      const combinedData = [
        headingPLC1,
        headers1.reduce((acc, key) => ({ ...acc, [key]: key }), {}),
        ...plc1DataForCSV,
        separatorRow,
        headingPLC2,
        headers2.reduce((acc, key) => ({ ...acc, [key]: key }), {}),
        ...plc2DataForCSV,
      ];
  
      // Exporting to CSV
      const options = {
        headers: false, // No need to auto-generate headers as they are included in the data
      };
  
      new AngularCsv(combinedData, "Eboiler Parameters", options);
      setTimeout(()=>{this.downloading=false},1000)
    } else {
      const headingPLC1 = {
        index: "PLC1 Data",
        Datetime: "",
        ...keys1.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
      };
  
      const plc1DataWithHeading = [
        headingPLC1,
        headers1.reduce((acc, key) => ({ ...acc, [key]: key }), {}),
        ...plc1DataForCSV,
      ];
  
      const options = {
        headers: false, // No need to auto-generate headers as they are included in the data
      };
  
      new AngularCsv(plc1DataWithHeading, "Eboiler Parameters", options);
      setTimeout(()=>{this.downloading=false},1000)
    }
  }

  // downloadParametersValue() {
  //   console.log(this.parametersList, "parameterslist");

  //   // Assuming each object in totalParameters (PLC1) has the same keys
  //   const keys1 = Object.keys(this.plc1Parameters[0]);
  //   const headers1 = ["index", "Datetime", ...keys1];

  //   // Prepare data for PLC1
  //   const plc1DataForCSV = this.plc1Parameters.map((item, index) => {
  //     let obj = {
  //       index: index,
  //       Datetime: new ConvertDatetimePipe().convertDateTime(
  //         moment(item.Datetime).format("YYYY-MM-DD HH:mm:ss")
  //       ),
  //     };
  //     // Add all key-value pairs from the item
  //     keys1.forEach((key) => {
  //       obj[key] =
  //         item[key] === "0" ? "off" : item[key] === "1" ? "on" : item[key];
  //     });
  //     return obj;
  //   });

  //   // Assuming each object in parametersList (PLC2) has the same keys
  //   if(this.plc2Parameters.length !== 0){
  //     const keys2 = Object.keys(this.plc2Parameters[0]);
  //   const headers2 = ["index", "Datetime", ...keys2];

  //   // Prepare data for PLC2
  //     console.log(this.plc2Parameters,'plc2 para')
  //   const plc2DataForCSV = this.plc2Parameters.map((item, index) => {
  //     let obj = {
  //       index: index,
  //       Datetime: new ConvertDatetimePipe().convertDateTime(
  //         moment.utc(item.Datetime).toDate()
  //       ),
  //     };
  //     // Add all key-value pairs from the item
  //     keys2.forEach((key) => {
  //       obj[key] =
  //         item[key] === "0" ? "off" : item[key] === "1" ? "on" : item[key];
  //     });
  //     return obj;
  //   });
  //     // Combine data with a separator row and headers
  //     const headingPLC1 = {
  //       index: "PLC1 Data",
  //       Datetime: "",
  //       ...keys1.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
  //     };
  //     const headingPLC2 = {
  //       index: "PLC2 Data",
  //       Datetime: "",
  //       ...keys2.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
  //     };
  //     const separatorRow = {
  //       index: "",
  //       Datetime: "",
  //       ...keys1.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
  //     };

  //     const combinedData = [
  //       headingPLC1,
  //       headers1.reduce((acc, key) => ({ ...acc, [key]: key }), {}),
  //       ...plc1DataForCSV,
  //       separatorRow,
  //       headingPLC2,
  //       headers2.reduce((acc, key) => ({ ...acc, [key]: key }), {}),
  //       ...plc2DataForCSV,
  //     ];

  //   // Exporting to CSV
  //     const options = {
  //       headers: false, // No need to auto-generate headers as they are included in the data
  //     };

  //     new AngularCsv(combinedData, "Eboiler Parameters", options);
  //   }else{
  //     const headingPLC1 = {
  //       index: "PLC1 Data",
  //       Datetime: "",
  //       ...keys1.reduce((acc, key) => ({ ...acc, [key]: "" }), {}),
  //     };
  //     const options = {
  //       headers: false, // No need to auto-generate headers as they are included in the data
  //     };
  //     new AngularCsv(headingPLC1, "Eboiler Parameters", options);
  //   }
  //   // const keys2 = Object.keys(this.plc2Parameters[0]);
  //   // const headers2 = ["index", "Datetime", ...keys2];

  //   // // Prepare data for PLC2
  //   // console.log(this.plc2Parameters,'plc2 para')
  //   // const plc2DataForCSV = this.plc2Parameters.map((item, index) => {
  //   //   let obj = {
  //   //     index: index,
  //   //     Datetime: new ConvertDatetimePipe().convertDateTime(
  //   //       moment.utc(item.Datetime).toDate()
  //   //     ),
  //   //   };
  //   //   // Add all key-value pairs from the item
  //   //   keys2.forEach((key) => {
  //   //     obj[key] =
  //   //       item[key] === "0" ? "off" : item[key] === "1" ? "on" : item[key];
  //   //   });
  //   //   return obj;
  //   // });

   
  // }
  //for threshold value
  public async getEboilerAllThresholdSettingsDataByID(
    metric_type: string
  ): Promise<any> {
    try {
      const sensorRes = await this.service
        .getDataWithQuery(
          `${this.parametersThrsholdApi}metrics/parameters/${this.clientId}/${this.subsystemId}?metric_type=${metric_type}`
        )
        .then((res) => {
          return res;
        });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;

      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error("No data found in sensor response");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  openEboilerAllThresholdSetting(metric_type: string): void {
    this.loader = true;
    this.getEboilerAllThresholdSettingsDataByID(metric_type)
      .then((data: any) => {
        //set data into GraphScaleSettingData variable.
        this.GraphScaleSettingData = [];
        let response = data.body;
        this.loader = false;
        //this.GraphScaleSettingData.push({metric_type:metric_type, asset_id:asset_id, green:response.threshold_1,yellow:response.threshold_2,red:response.threshold_3,max_value:response.max_value,min_value:response.base_value});
        this.GraphScaleSettingData = response;
        //Open Dialog Box.
        const mergedDialogConfig = {
          width: "1000px",
          height: "800px",
          data: {
            type: "allMertrics",
            dataAll: this.GraphScaleSettingData,
          },
          disableClose: true, // Additional configuration option
          autoFocus: true, // Additional configuration option
        };
        const dialogRef = this.dialog.open(
          DialogThresholdSettingsComponent,
          mergedDialogConfig
        );

        //Closed Dialog box
        dialogRef.afterClosed().subscribe((updatedSettings) => {
          if (updatedSettings) {
            // console.log(updatedSettings)
            this.saveMetricSettings(updatedSettings);
            this.parametersList[updatedSettings.index]
            // updatedSettings.forEach(setting=>{
            //     this.parametersList[setting.index].loader=true;
            // })
            updatedSettings.forEach(setting=>{
              const matchingParam=this.parametersList.find(param=>param.name == setting.changedObject.metric_name)
              // console.log(matchingParam)
              if(matchingParam) matchingParam.loader=true;
            })
            // setTimeout(()=>{
            //   this.getAllParameters();
            // },2000)
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.loader = false;
        // Handle error here
      });
  }
  //end threshold value
  saveMetricSettings(updatedSettings: any): void {
    this.service
      .putData(
        this.parametersThrsholdApi + "metrics/" + this.subsystemId,
        updatedSettings
      )
      .then(
        () => {
          this.service.showSuccess("Settings saved successfully");
          this.getAllParameters();
          // console.log("Settings saved successfully");
        },
        (error) => {
          console.error("Error saving settings:", error);
        }
      );
  }
  getChartParameters(columnName) {
    this.chartloader = true;
    this.service
      .getDataWithQuery(
        this.parametersHistoricalData +
          "parameters/" +
          columnName +
          "/" +
          this.clientId +
          "/" +
          this.subsystemId +
          "/" +
          "hour"
      )
      .then((res) => {
        this.chartloader = true;
        let response = JSON.parse(JSON.stringify(res)).data;
        if (response.body && Object.keys(response.body).length !== 0) {
          let responseData = response.body;
          this.ChartDataForParameter = [];
          this.parameterChartColors = [];
          console.log(response, "respobsee");
          this.parameterChartOptions = responseData.name;
          if (responseData.sensor != undefined) {
            if (responseData.sensor.length != 0) {
              let barData = response.sensor;
              this.firingRateChartData.push(barData);
              this.movingAvg = response.body.movingAvg;
              console.log(this.movingAvg, "moveicc");
            }
            if (responseData.sensor.length != 0) {
              let barData = responseData.sensor;
              this.ChartDataForParameter.push(barData);
            }

            if (responseData.rangeLabels.length != 0) {
              this.parameterChartColors.push(responseData.rangeLabels);
            }

            if (
              this.ChartDataForParameter.length >= 1 ||
              this.parameterChartColors.length > 0
            ) {
              setTimeout(() => {
                this.parameterChartloading = false;
              }, 3000);
            }
            this.chartloader = false;
          }
          this.dialog.open(ParametersChartComponent, {
            width: "2400px",
            height: "860px",
            data: {
              chartContainerId: columnName,
              chartData: this.ChartDataForParameter[0],
              movingAvgData: this.movingAvg,
              chartOptions: this.parameterChartOptions,
              chartBgColors: this.parameterChartColors[0],
            },
          });
        } else {
          this.chartloader = false;
        }
      });
  }
}
